import { HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NbAuthJWTToken, NbAuthModule, NbPasswordAuthStrategy, NbPasswordAuthStrategyOptions, routes } from '@nebular/auth';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import {
  NbButtonModule, NbCardModule,
  NbGlobalPhysicalPosition, NbLayoutModule, NbMenuModule, NbSidebarModule, NbThemeModule,
  NbToastrModule
} from '@nebular/theme';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { ExternalModule } from './external/external.module';
import { httpInterceptorProviders } from './http-interceptors';
import { ThousandSeparatorPipe } from './services/Pipes/thousand-separator.pipe';
import { DialogLogoutModule } from './auth/dialog/dialog-logout/dialog-logout.module';
import { DialogConfirmModule } from './auth/dialog/dialog-confirm/dialog-confirm.module';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from './utils/datePickerFiltros';
import { SpinnerGeneralModule } from './spinner-general/spinner-general.module';
import { ConfigLoginService } from './auth/config-login.service';
import { Router } from '@angular/router';
// import { NgxPrintModule } from 'ngx-print';

export function loadConfig(configLoginService: ConfigLoginService, router: Router) {
  return () =>
    configLoginService.loadConfig().toPromise()
      .then(config => {
        let loginType = '';
        if (config === '1') {
          loginType = 'login'
        } else if (config === '2') {
          loginType = 'loginDav'
        } else {
          router.navigate(['/auth/404NotFound']);
          return;
        }
        configLoginService.setLoginType(loginType);
      })
      .catch(() => {
        console.log('Error al determinar el tipo de Login');
        router.navigate(['/auth/404NotFound']);
      });
}

@NgModule({
  declarations: [
    AppComponent,
    ThousandSeparatorPipe
  ],
  imports: [
    // MatSnackBarModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    DialogLogoutModule,
    DialogConfirmModule,
    ToastrModule.forRoot({
      disableTimeOut: true,
      tapToDismiss: false,
      progressBar: true,
      onActivateTick: true,
      closeButton: true,
      positionClass: 'toast-top-center',
      preventDuplicates: true
    }),
    HttpClientModule,
    NgbModule,
    DashboardModule,
    ExternalModule,
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email',
          baseEndpoint: '/api',
          login: {
            endpoint: '/Account/Login',
            method: 'post',
            redirect: {
              success: '/auth/perfil',
              failure: null
            }
          },
          logout: {
            endpoint: undefined,
            redirect: {
              success: '/auth/login',
              failure: null
            }
          },
          requestPass: {
            endpoint: '/Account/PostEnviarCorreoRecuperarContrasenna',
            method: 'post',
            redirect: {
              success: '/auth/reset-password',
              failure: '/auth/request-password'
            },
            defaultErrors: ['Algo salió mal, por favor inténtalo de nuevo.'],
            defaultMessages: ['Las instrucciones para restablecer la contraseña han sido enviadas a tu correo electrónico.'],
          },
          resetPass: {
            endpoint: '/Account/PostCambiarContrasennaRecuperar',
            method: 'post',
            redirect: {
              success: '/auth/login',
              failure: null
            },
            defaultErrors: ['Algo salió mal, por favor inténtalo de nuevo.'],
            defaultMessages: ['Tu contraseña se ha cambiado exitosamente.'],
          },
          token: {
            class: NbAuthJWTToken,
            key: 'token'
          },
          errors: {
            getter: (_module: string, res: HttpErrorResponse, _options: NbPasswordAuthStrategyOptions) => res.error
          }
        })
      ],
      forms: {
        login: {
          redirectDelay: 0,
          strategy: 'email',
          rememberMe: true,
          showMessages: {
            success: false
          },
          logout: {
            redirectDelay: 3000,
            strategy: 'email',
            showMessages: {
              success: true
            },
          },
        },
        requestPass: {
          redirectDelay: 5000,
          strategy: 'email',
          rememberMe: false,
          showMessages: {
            success: true,
            error: true,
          },
        },
        resetPass: {
          redirectDelay: 5000,
          strategy: 'email',
          rememberMe: false,
          showMessages: {
            success: true,
            error: true,
          },
        },
      }
    }),
    NbCardModule,
    NbButtonModule,
    NbEvaIconsModule,
    NbLayoutModule,
    NbMenuModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbThemeModule.forRoot({ name: 'prozesslaw' }),
    NbToastrModule.forRoot({
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: true
    }),
    SpinnerGeneralModule
  ],
  providers: [
    httpInterceptorProviders,
    ConfigLoginService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfig,
      deps: [ConfigLoginService, Router],
      multi: true
    },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
  ,
  bootstrap: [AppComponent]
})
export class AppModule { }
